import React from "react";
import axios from "axios";
import {
  FormCheckboxField,
  FormToggleSwitch,
} from "../../components/form/checkbox";
import { FormDateField, FormTimeField } from "../../components/form/date";
import {
  FormDropDown,
  FormMultiSelectDropDown,
} from "../../components/form/dropdown";
import { FormFileUploadField } from "../../components/form/file";
import { FormImageField } from "../../components/form/image";
import FormJsonEditor from "../../components/form/json";
import { FormMultiFileUploadField } from "../../components/form/multi-file";
import { FormMultiImageField } from "../../components/form/multi-image";
import FormTextField from "../../components/form/text";
import { FormTextAreaField } from "../../components/form/text-area";
import { url } from "../../config";
import MainLayout from "../../layout";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { uiTypes } from "../../utils/types";
import { FormDropDownDynamic } from "../../components/form/dynamic-dropdown";
import { formatUnderscoreToSpace } from "../../utils/text-format";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import FormTextArrayField from "../../components/form/text-array";
import { FormMultiImageVideoField } from "../../components/form/multi-image-video";
import { FormLocationPickerField } from "../../components/map/map-selector";
import { FormDocumentField } from "../../components/form/document-field";

const Createpage = ({ model }) => {
  const navigate = useNavigate();
  const { tableName, columns, references } = model;

  const columnHeadings = () => {
    var array = [];
    for (var i = 0; i < columns.length; i++) {
      var column = columns[i];
      if (column.ui?.create === null || column.ui.create === true) {
        array.push(column.name);
      }
    }
    return array;
  };

  const headings = columnHeadings();

  const initialValues = columns.reduce((data, column) => {
    if (column.ui?.create == null || column.ui.create === true) {
      if (
        column.ui?.type === uiTypes?.SWITCH ||
        column.ui?.type === uiTypes?.CHECKBOX
      ) {
        data[column.name] = false;
      } else {
        data[column.name] = null;
      }
    }
    return data;
  }, {});

  // const getValidationType = (validations = []) => {
  //   let validationSchema;

  //   if (validations.includes(validatorTypes.string))
  //     validationSchema = Yup.string();
  //   else if (validations.includes(validatorTypes.email))
  //     validationSchema = Yup.string().email("Invalid email");
  //   else if (validations.includes(validatorTypes.uuid))
  //     validationSchema = Yup.string().uuid("Invalid UUID");
  //   else if (validations.includes(validatorTypes.number))
  //     validationSchema = Yup.number();
  //   else if (validations.includes(validatorTypes.bool))
  //     validationSchema = Yup.boolean();
  //   else if (validations.includes(validatorTypes.date))
  //     validationSchema = Yup.date();
  //   else if (validations.includes(validatorTypes.array))
  //     validationSchema = Yup.array();
  //   else validationSchema = Yup.string();

  //   if (validations.includes(validatorTypes.required)) {
  //     validationSchema = validationSchema.required("This field is required");
  //   } else if (validations.includes(validatorTypes.optional)) {
  //     validationSchema = validationSchema.notRequired();
  //   }

  //   return validationSchema;
  // };

  const validationSchema = Yup
    .object
    // model.columns.reduce((data, column) => {
    //   if (column.ui?.create == null || column.ui.create === true) {
    //     data[column.name] = getValidationType(column.ui?.validation);
    //   }
    //   return data;
    // }, {})
    ();

  const handleSubmit = (values) => {
    console.log("Submitted values:", values);
    axios
      .post(`${url}/model/${tableName}/create`, values)
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        navigate(`/${tableName}/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const enumToOptions = (enumValues = []) =>
    enumValues.map((val) => ({
      label: val.charAt(0).toUpperCase() + val.slice(1),
      value: val,
    }));

  return (
    <MainLayout>
      <section className="h-full overflow-auto ms:px-3">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ values }) => (
            <Form>
              <div className="flex flex-col md:flex-row justify-between md:items-center mb-5 sticky top-0 bg-background py-2 z-[5000] gap-2">
                <h2 className="text-fs_16 font-semibold capitalize">
                  {formatUnderscoreToSpace(tableName)} - Create
                </h2>
                <div className="flex gap-3 items-center justify-end">
                  <button
                    onClick={() => navigate(`/${tableName}/list`)}
                    type="button"
                    className="text-fs_14 md:text-fs_16 px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="text-fs_14 md:text-fs_16 px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                  >
                    Create
                  </button>
                </div>
              </div>
              <section className="w-full max-w-[40rem]">
                {headings?.map((heading, index) => {
                  const column = columns.find(
                    (value) => value.name === heading
                  );
                  if (
                    (column.ui?.create === null ||
                      column?.ui?.create === true) &&
                    column?.ui?.type === uiTypes?.SWITCH
                  ) {
                    return (
                      <FormToggleSwitch
                        name={heading}
                        label={heading}
                        value={values?.[heading]}
                      />
                    );
                  }
                  if (
                    (column.ui?.create === null ||
                      column?.ui?.create === true) &&
                    column?.ui?.type === uiTypes?.NUMBER
                  ) {
                    return (
                      <FormTextField
                        name={heading}
                        label={heading}
                        placeholder={`Enter ${heading}`}
                        type="number"
                      />
                    );
                  }
                  if (
                    (column.ui?.create === null ||
                      column?.ui?.create === true) &&
                    column?.ui?.type === uiTypes?.TEXT_ARRAY
                  ) {
                    return (
                      <FormTextArrayField name={heading} label={heading} />
                    );
                  }

                  if (
                    (column.ui?.create === null ||
                      column?.ui?.create === true) &&
                    column?.ui?.type === uiTypes?.CHECKBOX
                  ) {
                    return <FormCheckboxField name={heading} label={heading} />;
                  }
                  if (
                    (column.ui?.create === null ||
                      column?.ui?.create === true) &&
                    column?.ui?.type === uiTypes?.TIME
                  ) {
                    return <FormTimeField name={heading} label={heading} />;
                  }
                  if (
                    (column.ui?.create === null ||
                      column?.ui?.create === true) &&
                    column?.ui?.type === uiTypes?.DATE
                  ) {
                    return <FormDateField name={heading} label={heading} />;
                  }
                  if (
                    (column.ui?.create === null ||
                      column?.ui?.create === true) &&
                    column?.ui?.type === uiTypes?.DATE_TIME
                  ) {
                    return (
                      <FormDateField
                        name={heading}
                        label={heading}
                        type="datetime-local"
                      />
                    );
                  }

                  if (
                    (column.ui?.create === null ||
                      column?.ui?.create === true) &&
                    column?.ui?.type === uiTypes?.TEXT_AREA
                  ) {
                    return (
                      <FormTextAreaField
                        name={heading}
                        label={heading}
                        placeholder={`Enter ${heading}`}
                      />
                    );
                  }

                  if (
                    (column.ui?.create === null ||
                      column?.ui?.create === true) &&
                    column?.ui?.type === uiTypes?.DROPDOWN
                  ) {
                    if (!column?.enumValues) {
                      var reference = references.find(
                        (value) => value.foreignKey === heading
                      );
                      return (
                        <FormDropDownDynamic
                          name={heading}
                          label={heading}
                          reference={reference}
                          placeholder="Select"
                        />
                      );
                    }

                    return (
                      <FormDropDown
                        name={heading}
                        label={heading}
                        options={enumToOptions(column?.enumValues)}
                        value={enumToOptions(column?.enumValues)?.find(
                          (item) => item?.value === values?.[heading]
                        )}
                      />
                    );
                  }

                  if (
                    (column.ui?.create === null ||
                      column?.ui?.create === true) &&
                    column?.ui?.type === uiTypes?.DROPDOWN_MULTISELECT
                  ) {
                    return (
                      <FormMultiSelectDropDown
                        name={heading}
                        label={heading}
                        options={enumToOptions(column?.enumValues)}
                        value={enumToOptions(column?.enumValues)?.find(
                          (item) => item?.value === values?.[heading]
                        )}
                      />
                    );
                  }

                  if (
                    (column.ui?.create === null ||
                      column?.ui?.create === true) &&
                    column?.ui?.type === uiTypes.IMAGE
                  ) {
                    return <FormImageField name={heading} label={heading} />;
                  }

                  if (
                    (column.ui?.create === null ||
                      column?.ui?.create === true) &&
                    column?.isArray &&
                    column?.ui?.type === uiTypes.MULTI_IMAGE
                  ) {
                    return (
                      <FormMultiImageField name={heading} label={heading} />
                    );
                  }
                  if (
                    (column.ui?.create === null ||
                      column?.ui?.create === true) &&
                    column?.isArray &&
                    column?.ui?.type === uiTypes.MULTI_IMAGE_VIDEO
                  ) {
                    return (
                      <FormMultiImageVideoField
                        name={heading}
                        label={heading}
                      />
                    );
                  }

                  if (
                    (column.ui?.create === null ||
                      column?.ui?.create === true) &&
                    column?.ui?.type === uiTypes.DOCUMENT
                  ) {
                    return <FormDocumentField name={heading} label={heading} />;
                  }

                  if (
                    (column.ui?.create === null ||
                      column?.ui?.create === true) &&
                    column?.ui?.type === uiTypes.FILE
                  ) {
                    return (
                      <FormFileUploadField
                        name={heading}
                        label={heading}
                        accept=".pdf,.doc,.docx"
                      />
                    );
                  }
                  if (
                    (column.ui?.create === null ||
                      column?.ui?.create === true) &&
                    column?.isArray &&
                    column?.ui?.type === uiTypes.MULTI_FILE
                  ) {
                    return (
                      <FormMultiFileUploadField
                        name={heading}
                        label={heading}
                        accept=".pdf,.doc,.docx,.jpg,.png"
                      />
                    );
                  }

                  if (
                    (column.ui?.create === null ||
                      column?.ui?.create === true) &&
                    column?.ui?.type === uiTypes?.MAP
                  ) {
                    return (
                      <FormLocationPickerField
                        name={heading}
                        label={heading}
                        value={column?.defaultValue}
                      />
                    );
                  }

                  if (
                    (column.ui?.create === null ||
                      column?.ui?.create === true) &&
                    column?.ui?.type === uiTypes?.JSON
                  ) {
                    return (
                      <FormJsonEditor
                        name={heading}
                        label={heading}
                        value={column?.defaultValue}
                      />
                    );
                  }

                  return (
                    <React.Fragment key={index}>
                      {(column.ui?.create === null ||
                        column?.ui?.create === true) && (
                        <FormTextField
                          label={heading}
                          name={heading}
                          placeholder={`Enter ${heading}`}
                        />
                      )}
                    </React.Fragment>
                  );
                })}
              </section>
            </Form>
          )}
        </Formik>
      </section>
    </MainLayout>
  );
};

export default Createpage;
